/** Consistent page title + optional description + right-aligned actions. */
import * as React from "react";

export interface PageHeaderProps {
  title: React.ReactNode;
  /**
   * A string in almost every case. Widened to a node for the subject pages,
   * whose subtitle carries an id worth shortening and copying rather than
   * printing 64 hex characters across the header.
   */
  description?: React.ReactNode;
  actions?: React.ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps): React.ReactElement {
  return (
    <div className="mb-5 flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 flex-1 basis-64">
        <h1 className="text-xl font-semibold tracking-tight text-foreground">{title}</h1>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
